import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function PlayerCards({ name, cards, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <h4>{name}</h4>{" "}
      <div className="casino-result-cards">
        {/* Reference markup has a space text node before every card (inline-block spacing) */}
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}
        {cards.map((c, i) => (
          <React.Fragment key={i}>
            {" "}
            <div className="casino-result-cards-item">
              <img src={getCardImage(c)} alt="" />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

/**
 * Reference result body for Teenpatti 1-day (pteen): cards A=[0,2,4], B=[1,3,5],
 * trophy before the winner's cards, and rdesc "winner#suits#odd-even#consecutive"
 * shown as Winner / Odd/Even / Consecutive (the reference hides the suits line).
 */
export default function Teen1DayResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim()).filter(Boolean);
  const a = [0, 2, 4].map((i) => cards[i]).filter(Boolean);
  const b = [1, 3, 5].map((i) => cards[i]).filter(Boolean);
  const win = String(t1?.win ?? "");
  const [winner = "", , oddEven = "", consecutive = ""] = String(t1?.rdesc || "").split("#");

  return (
    <div className="row row5">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <PlayerCards name="Player A" cards={a} isWinner={win === "1"} />{" "}
          <div className="casino-result-content-diveder" />{" "}
          <PlayerCards name="Player B" cards={b} isWinner={win === "2"} />
        </div>
      </div>{" "}
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div> <div>{winner}</div>
          </div>{" "}
          <div className="casino-result-desc-item">
            <div>Odd/Even</div> <div>{oddEven}</div>
          </div>{" "}
          <div className="casino-result-desc-item">
            <div>Consecutive</div> <div>{consecutive}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
